import { render, staticRenderFns } from "./PuntajePage.vue?vue&type=template&id=1397d866"
import script from "./PuntajePage.js?vue&type=script&lang=js&external"
export * from "./PuntajePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports